module.exports = function () {
    for (var i = 0; i < arguments.length; i++) {
        if (arguments[i] !== undefined) return arguments[i];
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/defined/index.js
// module id = 94
// module chunks = 0